import Common from '../../wp-controlers/common-panel/geralAttributes';

export default {
  text: {
    type: 'string',
    default: '',
  },
  buttonHref: {
    type: 'string',
    default: '',
  },
  buttonTarget: {
    type: 'boolean',
    default: false,
  },
  variant: {
    type: 'string',
    default: 'default',
  },
  size: {
    type: 'string',
    default: '',
  },
  align: {
    type: 'string',
    default: 'left',
  },
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  iconPosition: {
    type: 'string',
    default: 'iconDefault',
  },
  hideOnMobile: {
    type: 'boolean',
    default: false,
  },
  hideOnDesktop: {
    type: 'boolean',
    default: false,
  },
  target: {
    type: 'boolean',
    default: false,
  },
  ...Common,
};
